import React, { useState } from 'react';

export const MobileCasinoSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Мобильные казино онлайн',
      subtitle: 'для игры на ходу',
      quote: 'Современные мобильные казино предлагают полный функционал десктопной версии с оптимизацией для сенсорных экранов и быстрой загрузкой даже при слабом интернете',
      image: 'https://public.readdy.ai/ai/img_res/156e9da1f45dd7025fd9b1642f000552.jpg'
    },
    {
      title: 'Мобильные приложения казино',
      subtitle: 'удобство и скорость',
      quote: 'Нативные приложения для iOS и Android обеспечивают максимальную производительность, push-уведомления о бонусах и возможность играть офлайн в демо-режиме',
      image: 'https://readdy.ai/api/search-image?query=sleek%20mobile%20phone%20showing%20casino%20application%20with%20live%20dealer%20games%20and%20betting%20interface%2C%20premium%20mobile%20gambling%20experience%2C%20elegant%20product%20photography%20on%20gradient%20blue%20background%2C%20professional%20studio%20lighting%2C%20photorealistic%20quality&width=600&height=800&seq=25&orientation=portrait'
    },
    {
      title: 'Мобильные казино онлайн',
      subtitle: 'безопасность превыше всего',
      quote: 'Все мобильные казино из нашего рейтинга используют современное SSL-шифрование, двухфакторную аутентификацию и биометрическую защиту для максимальной безопасности',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20secure%20casino%20app%20showing%20fingerprint%20authentication%20and%20encryption%20symbols%2C%20mobile%20security%20concept%2C%20professional%20tech%20illustration%20on%20soft%20blue%20background%2C%20modern%20clean%20design%2C%20high%20quality%20digital%20art&width=600&height=800&seq=26&orientation=portrait'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="mobile" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="bg-sky-100 rounded-3xl p-8 flex items-center justify-center h-[600px]">
            <img
              src={slides[currentSlide].image}
              alt="Mobile Casino"
              className="w-full h-full object-contain"
            />
          </div>

          <div>
            <p className="text-sm text-gray-600 mb-2">(Тренд 2026)</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">
              {slides[currentSlide].title}
            </h2>
            <p className="text-2xl text-gray-500 mb-6">{slides[currentSlide].subtitle}</p>

            <blockquote className="text-lg text-gray-700 leading-relaxed mb-6 italic border-l-4 border-blue-600 pl-6">
              "{slides[currentSlide].quote}"
            </blockquote>

            <p className="text-base font-bold text-gray-900 mb-8">— Эксперты Casino-Rus.Online</p>

            <div className="flex gap-4">
              <button
                onClick={prevSlide}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-gray-900 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={nextSlide}
                className="w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};